<template>
  <div class="weapon-view-container">
    <h1 class="name sle">{{ weaponInfo.name }}</h1>
    <div class="weapon-info">
      <div class="left">
        <div class="summary">{{ weaponInfo.description || '' }}</div>
      </div>
    </div>
    <div class="weapon-pre-inner">
      <img v-if="weaponInfo.image" ref="weaponImage" src="" alt="weapon preview" />
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
import responsiveMixin from "@/mixins/responsive";
export default {
  mixins: [responsiveMixin],
  props: {
    weaponInfo: {
      type: Object,
      required: true,
      default: () => { }
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {
    this.initWeaponImage();

  },
  beforeDestroy() { },
  watch: {
    weaponInfo: {
      handler() {
        this.changeImage();
      },
      immediate: true
    }
  },
  methods: {
    // init weapon image
    initWeaponImage() {
      this.$nextTick(() => {
        if (!this.$refs.weaponImage) return;
        const url = this.weaponInfo.image;
        this.$refs.weaponImage.src = url;
        this.$refs.weaponImage.onload = () => {
          gsap.to(this.$refs.weaponImage, { opacity: 1, duration: 1 });
        };
      });
    },
    // change image
    changeImage() {
      // opacity -> 0 image
      if (this.$refs.weaponImage) {
        gsap.to(this.$refs.weaponImage, { opacity: 0, duration: 0.4, onComplete: this.loadNewImage });
      }
    },
    // load new image
    loadNewImage() {
      // get new image
      this.$refs.weaponImage.src = "";
      const url = this.weaponInfo.image;
      this.$refs.weaponImage.src = url;
      // onload image opacity -> 1
      gsap.to(this.$refs.weaponImage, { opacity: 1, duration: 1 });
    },
  }
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
